export function getMarker(thisWindow: Window, position: google.maps.LatLng, map?: google.maps.Map): google.maps.Marker {
  const svg = thisWindow.btoa(`
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="20" fill="#011936"/>
      <path d="M15.8857 13.8182L12.1357 27.75H10.0504L13.8004 13.8182H15.8857ZM20.8004 26V14.3636H25.3913C26.2739 14.3636 27.0258 14.5322 27.647 14.8693C28.2682 15.2027 28.7417 15.6667 29.0675 16.2614C29.397 16.8523 29.5618 17.5341 29.5618 18.3068C29.5618 19.0795 29.3951 19.7614 29.0618 20.3523C28.7285 20.9432 28.2455 21.4034 27.6129 21.733C26.9841 22.0625 26.2228 22.2273 25.3288 22.2273H22.4027V20.2557H24.9311C25.4046 20.2557 25.7947 20.1742 26.1016 20.0114C26.4122 19.8447 26.6432 19.6155 26.7947 19.3239C26.95 19.0284 27.0277 18.6894 27.0277 18.3068C27.0277 17.9205 26.95 17.5833 26.7947 17.2955C26.6432 17.0038 26.4122 16.7784 26.1016 16.6193C25.791 16.4564 25.397 16.375 24.9197 16.375H23.2607V26H20.8004Z" fill="white"/>
    </svg>
  `);

  return new google.maps.Marker(
    map
      ? {
          position,
          map,
          icon: {
            url: `data:image/svg+xml;base64,${svg}`,
            scaledSize: new google.maps.Size(40, 40), // @TODO: Ajout du responsive pour la size (desk: 4rem, mob: 2.4rem)
          },
        }
      : {
          position,
          icon: {
            url: `data:image/svg+xml;base64,${svg}`,
            scaledSize: new google.maps.Size(40, 40), // @TODO: Ajout du responsive pour la size (desk: 4rem, mob: 2.4rem)
          },
        }
  );
}
